import { render, staticRenderFns } from "./LamboPreOwnedColumn.vue?vue&type=template&id=140eaa9a&scoped=true&"
import script from "./LamboPreOwnedColumn.vue?vue&type=script&lang=js&"
export * from "./LamboPreOwnedColumn.vue?vue&type=script&lang=js&"
import style0 from "./LamboPreOwnedColumn.vue?vue&type=style&index=0&id=140eaa9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140eaa9a",
  null
  
)

export default component.exports